export default "__VITE_ASSET__tc3E5ZvA__"